const {
  getSolJourneyConfigForJourney,
} = require("./getSolJourneyConfigForJourney");
const { getVehicleRegistrationType } = require("./getVehicleRegistrationType");

const { VEHICLE_REGISTRATION_METHOD } = require("../../constants");

const getSelectedRegistrationConfiguration = (
  registrationType,
  journey,
  businessModel,
  configuration
) => {
  const { vehicleRegistration } = getSolJourneyConfigForJourney(
    journey,
    businessModel,
    configuration
  );

  // Accept any vehicleRegistration shape (canonical { type: string }, legacy string, corrupt).
  switch (getVehicleRegistrationType(registrationType)) {
    case VEHICLE_REGISTRATION_METHOD.MYSELF:
      return vehicleRegistration.selfRegistration;

    case VEHICLE_REGISTRATION_METHOD.CITROEN:
      return vehicleRegistration.citroenRegistration;

    default:
      return null;
  }
};

module.exports = { getSelectedRegistrationConfiguration };
